module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("F")]), _vm._v("our")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OW’S EVERYTHING")]), _vm._v("?” Eric Vernon said, sliding onto a bar stool next to Arliss Shepherd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arliss bobbed his head several times. Eric Vernon made him fidgety, he couldn’t figure out what the man was after. No one kept on buying drinks unless they were after something.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Another beer?” Eric offered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arliss bobbed his head again. Rule one: Never turn down a free drink—even though he still had a half-full bottle clutched in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pattie,” Eric said, snapping his fingers to attract the attention of a half-clad woman with a lopsided boob job, who toiled behind the scuffed wooden bar. “Another bottle for my friend.” He patted Arliss on the shoulder. “Been thinking about you,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have?” Arliss replied, stifling a fast-rising burp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I was remembering that conversation we had the other night.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("Arliss scratched his head. If the conversation wasn’t about tits and ass, he did not retain it.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” Eric continued, thinking that Arliss Shepherd smelled like a Mexican meal left out in the sun for a week. Putrid. But since he wasn’t about to hire him for his good hygiene, who cared if he stunk? “I was thinking ’bout how you said you hated your job.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I do,” Arliss agreed, nodding furiously. “I certainly do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And who wouldn’t? He was the caretaker of a big old building filled with nothing but rats and roaches and memories of the time it was a flourishing dress company. Why the owners needed a caretaker in a place they’d been threatening to pull down for years was beyond him. In the meantime, it was his job to keep the transients out and the place protected.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Protected from what? Who knew? Who cared?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He’d fashioned himself a makeshift apartment in the basement, and he didn’t have to answer to anyone—except the snotty-nosed son of the owner, who put in an occasional appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, what kind of an existence was it to be shut up in a deserted building all day and most of the night? Arliss wished for something better, although deep down he knew there wasn’t anything better. He had no qualifications, he could barely read, he was fortunate to have any kind of job at all. However, that certainly didn’t stop him from complaining, which, after several beers too many, he’d obviously been doing to this Eric Vernon character.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pattie slid a cold bottle of Heineken in front of him while shooting Eric a flirtatious sideways glance. This infuriated Arliss, because he’d been trying to get her to pay attention to him for months.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("“She’ll ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("give ya crabs,” he muttered to Eric as Pattie sashayed off.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric got it immediately. “Not interested,” he said abruptly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Why not?")]), _vm._v(" Arliss thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("You one of them faggot freaks?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prudently, he kept his thoughts to himself. If Eric Vernon was a fag it was none of his business as long as the man kept on buying. He lifted the cold bottle of beer to his lips. “You married?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Eric replied. “Are you?” He asked the question even though he already knew the answer. He knew everything about Arliss Shepherd that needed knowing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arliss shook his greasy head. “I’m stupid, not soft,” he said scornfully. “Wimmen give a man nothin’ but trouble.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right,” Eric agreed, his small, sharp eyes checking out the bar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“ ’Course, they’re all right for some things,” Arliss added with a lewd wink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric had endured enough small talk, weeks of it in fact. What he needed now was action. Leaning closer to Arliss, almost recoiling from the stink, he said, “How would you like to make some "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("real")]), _vm._v(" money?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arliss’ narrow face brightened. Real money. Who wouldn’t want to make a score? If he had real money he could buy himself a better life. “How’d I do that?” he asked, trying not to sound too eager.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By cooperating on something and keeping your mouth shut.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Somethin’ legal?” Arliss said suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If it means big bucks, do you care?” Eric shot back. He knew Arliss had done time for petty burglary, so he would not be averse to criminal activities.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How big "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("are")]), _vm._v(" the bucks?” Arliss ventured.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("“Enough to keep everyone happy,” Eric said, tapping his fingers on the bar. “I need to put together a team I can trust.”")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What kinda team?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ve been watching you and your friends. You all seem pretty tight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arliss did not take kindly to the thought that Eric had been spying on them. Davey and Joe, and especially Big Mark, would not like it either. Big Mark could crush this guy’s ass if Arliss gave him the word. Mark was the strong one in the group. He worked as a bouncer at a club on the Strip, and according to Mark, not a night passed unless he split some asshole’s lip or broke a nose or two.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re tight all right,” Arliss said stiffly. “Tight enough not to need any intruders.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t get me wrong,” Eric said quickly. “I’m looking for a few guys who can handle themselves in any situation "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" make big money doing it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Doin’ what?” Arliss asked, blinking rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter,” Eric said, backing off. “I sense you’re not interested.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Didn’t say that,” Arliss growled. “If it means big bucks—I could be ready t’do anythin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anything, huh?” Eric said, giving him an appraising look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Short of murder,” Arliss added with a nervous cackle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And even murder has a price, doesn’t it?” Eric said mildly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Arliss nodded, he couldn’t help himself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was then that Eric knew he had found the right man.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T NEVER OCCURRED")]), _vm._v(" to Eric that he could fail at the scam he was shortly to put into motion. Failure was not ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("a word in his vocabulary. Failure was his past, and he was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("never")]), _vm._v(" revisiting his miserable past.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Two months previously he’d been sent to a big movie star’s Bel Air mansion to do some work on her computers—upgrading, Mr. Hailey, his boss, had informed him. Usually Mr. Hailey took care of all the famous clients, but recently Mr. Hailey had been undergoing a punishing course of chemo treatments and was losing his hair, so he’d started sending Eric out on the more high-profile jobs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Hailey trusted Eric, who was quiet, always on time, and did his job well. And then, of course, there were Eric’s forged references attesting to his diligence and honesty. Those references had landed him the job.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How easy it was to clean the plate and start afresh. How simple it was to fool people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So one fine morning Eric had set off to the movie star’s Bel Air mansion, pressed the buzzer at the bottom of a long, winding driveway, and when the gates opened, had driven up to the house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was greeted by her assistant, a gregarious gay man with a halo of curly auburn hair and matching beard. He introduced himself as Danny and led Eric into the office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is her "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("home")]), _vm._v(" office,” Danny said. “Her "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("production")]), _vm._v(" offices are at Universal. I work "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("here.”")]), _vm._v(" A conspiratorial wink. “Lucky "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("me!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric had no idea who the celebrity was. He didn’t watch TV or go to the movies, and he certainly didn’t buy CDs or attend concerts. The walls of her office—covered in framed posters and photographs—soon clued him in. He recognized her as that slutty blonde who wore revealing outfits and sang controversial sexy songs. He recognized her because the con in the cell next to him had her picture pinned to his wall and had christened her “Queen of the Wankers.” Lissa Roman, that was her name.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("So here Eric was in the office of the Queen of the Wankers, and he didn’t give a damn because he didn’t like women, and he liked famous, rich ones even less.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Madam is not around today,” Danny announced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As if Eric cared. The last thing he needed was to check out some overblown movie-star tramp.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The princess is working on her new video,” Danny volunteered. “It’ll be amazing, as usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mmm . . .” Eric said, heading toward the two computers. “What needs doing here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sometimes Miz Roman enjoys dropping in to chat rooms,” Danny confided. “Naturally she uses an alias, but she likes to visit, and right now she’s not getting connected quickly enough, so I was told you could do something.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The phone company has to install a DSL line,” Eric said gruffly. “Then I can fix it so that everything happens faster. After the phone company’s done their work, I’ll come back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t understand this chat-room obsession some people have,” Danny said, pursing his lips. “Me—I’m bored by them. All those fifty-year-old men pretending to be twelve-year-old boys.” A sly giggle and a provocative glance. “Naughty, naughty!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Faggot,")]), _vm._v(" Eric thought. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I don’t want to hear about what you do in your spare time.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ms. Roman’s husband wishes to update some of their equipment,” Danny continued. “He was thinking of a new photo scanner, and perhaps the latest flat-screen computer. We’d like suggestions and price quotes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric nodded, checking out the equipment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A week later he returned with several new items.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This time Danny greeted him like a long-lost friend. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“So")]), _vm._v(" good to see you again,” Danny gushed. “Has life been treating you well?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Eric barely nodded and immediately went to work installing the new equipment, tuning out on Danny’s annoying chatter.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Why should some people have everything and he nothing? Oh, yes, he had a job, a van, and a one-room apartment, rented, but that was about it. Why couldn’t "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("he")]), _vm._v(" enjoy the luxuries that all these rich people seemed to possess? Why couldn’t "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("he")]), _vm._v(" be living in a mansion with a swimming pool and several cars in the driveway?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Exactly what had this Lissa Roman bitch done to deserve such recognition anyway? Sung some slutty songs and exhibited her body in a few commercial movies. Any little tramp could do that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And then Lissa Roman herself put in an appearance. The woman had porcelain skin, white-blond hair, ruby-red lips, and a welcoming smile that revealed small, sharp teeth. “I’m so glad you’re doing this,” she said in a low throaty voice. “Would you like a copy of my latest CD—maybe for your wife or someone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” he said, frowning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She looked a little taken aback that he hadn’t jumped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that moment it occurred to him that Lissa Roman thought everyone loved her. Well, she was wrong. She was standing in a room with someone who couldn’t give a rat’s ass.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Danny obligingly handed her one of her CDs and a pen. She turned to Eric with a bright smile. “To whom shall I sign it?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Eric,” he muttered, watching her carefully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She signed the CD with a flourish and handed it to him. She’d written, "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("To Eric—with love, Lissa Roman.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Want me to explain how this new scanner works?” he asked, shoving the CD in his back pocket to be thrown away later.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("“No,” she said, shaking her platinum head. “Danny will fill me in. Nice meeting you, Eric.” And she left the room, leaving behind a trail of exotic perfume.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Isn’t she a treat?” Danny enthused when she’d gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric grunted. He didn’t find her a treat at all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("so")]), _vm._v(" nice to everyone,” Danny said reverently. “Such a "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("lady.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Lady, my ass,")]), _vm._v(" Eric thought as he continued working. And then he noticed the two trade papers casually laid out on Danny’s desk. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Variety")]), _vm._v(" and "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("The Hollywood Reporter.")]), _vm._v(" They both sported stories on the front page about Lissa Roman. Danny had outlined the pieces in thick red pen, ready to put in her scrapbook.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he worked, Eric managed to read the headlines.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LISSA ROMAN INKS THREE-MILLION-DOLLAR DEAL FOR ONE NIGHT’S WORK AT DESERT MILLENNIUM PRINCESS HOTEL")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three million dollars. Eric was in shock. That amount of money could buy him everything he’d always craved. And this blond bitch was making it in one night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He managed to scan the other headline, which was much the same. She was opening a new hotel in Vegas, for which they were paying her three million big ones. Jesus!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then it came to him in a flash. What if he "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("kidnapped")]), _vm._v(" her and held her for "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("ransom")]), _vm._v("? Would her record company pay? Would her movie bosses cough up? Or would the cops come down so hard that they’d find her before he could collect the ransom?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Back at the office he looked her up on the Internet. There were over eight hundred sites devoted to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He clicked on to several of the main ones and found out more than he ever wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was very, very famous. Too famous.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("She’d made seven movies. Released ten bestselling CDs. Appeared on over a thousand magazine covers. Been married four times.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("How did he go about kidnapping someone with such a high profile? This obviously needed meticulous planning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over the next few weeks he spent all his spare time following her, soon discovering she was an extremely well protected woman who never went anywhere by herself. She was always accompanied by a publicist, a driver, sometimes guards, and often her husband—a muscle-bound man who appeared never to work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric realized that kidnapping Lissa Roman was not going to be an easy task.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He decided that befriending Danny—her loyal assistant—might be a good plan. So he called him up, reminded Danny who he was, and suggested they meet for a drink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Danny agreed, and they met at a gay bar on Santa Monica Boulevard.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My boyfriend would be livid if he suspected I was stepping out on him,” Danny said archly. “However, he’s away in Seattle for the weekend, so no harm.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eric knew exactly how to deal with fags, after all, he’d been incarcerated with a whole bunch of them for six long, miserable years. He proceeded to get Danny good and drunk, then questioned him, finding out everything he wanted to know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the end of the evening he had his answer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa Roman had a daughter, Nicci, who did not live with her. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Nicci")]), _vm._v(" was the one he should be targeting. Nicci was the perfect victim.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And from that moment on, Nicci had become his obsession.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5d0c9ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch04.vue
// module id = 84
// module chunks = 0